import {graphql} from 'gatsby'

import {Maybe} from 'src/graphql-generated'
import FlairBox from 'src/components/FlairBox'
import {FlairProvider} from 'src/context/FlairContext'
import {Flex, Box} from 'src/components/Box'
import {Header2, Body} from 'src/components/text'

interface Props {
  title: string
  description?: Maybe<string>
}

export const query = graphql`
  fragment GroupCard on ContentfulGroup {
    __typename
    id
    name
    description {
      description
    }
  }
`

const Group = ({title, description}: Props) => (
  <FlairProvider seed={1}>
    <Flex
      flexDirection="column"
      justifyContent="center"
      width={{md: '675px'}}
      mt={{_: '8', lg: '9'}}
      mb="3"
      mx="auto"
      data-cy="journey-group"
    >
      <Box position="relative" alignSelf="center">
        <FlairBox height={100} width={100} top={-45} right={-55} />
        <Header2>{title}</Header2>
      </Box>
      {description && (
        <Body mt={{_: '2', lg: 3}} color="grey6">
          {description}
        </Body>
      )}
    </Flex>
  </FlairProvider>
)

export default Group
